import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Footer.scss';

class FooterItem extends Component {
  static displayName = 'FooterItem';
  static propTypes = {
    iconClass: PropTypes.string,
    iconSvgPath: PropTypes.string,
    title: PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
          label: PropTypes.string.isRequired,
          href: PropTypes.string.isRequired
        })
      ])
    ),
    links: PropTypes.bool
  };
  render() {
    const title = this.props.title.map((ele, idx) => {
      const item = typeof ele === 'string' ? { label: ele, href: `https://www.${ele}` } : ele;
      if (this.props.links) {
        return (
          <div key={`${item.label}-${idx}`}>
            <a href={item.href}
              target='_blank'
              rel='noopener noreferrer'
              className='footer-anchor'>
              {item.label}
            </a>
          </div>
        );
      } else {
        return (
          <div key={`${item.label}-${idx}`}>{item.label}</div>
        );
      }
    });

    return (
      <div className='footer-item'>
        <div className="footer-icon-circle">
          <div className="footer-icon">
            {this.props.iconSvgPath ? (
              <svg
                className="footer-icon-svg"
                viewBox="0 0 24 24"
                aria-hidden="true">
                <path d={this.props.iconSvgPath}></path>
              </svg>
            ) : (
              <i className={this.props.iconClass} aria-hidden="true"></i>
            )}
          </div>
        </div>
        <div className='footer-title'>
          {title}
        </div>
      </div>
    );
  }
}

export default FooterItem;
